import { Badge } from '@karnov/kui-react'

import { KarnovDocumentReference } from 'api/conversations/types'
import { Text } from 'components/Text'
import { useTranslation } from 'services/i18n'
import { useIsLgOrAbove } from 'stores/useScreenSizeStore'

type Props = {
  reference: KarnovDocumentReference
}

export const KarnovDocumentHeader = ({
  reference: {
    metadata: {
      categories,
      citations,
      documentCategoryTitle,
      sectionTitle,
      title,
    },
    annotationType,
    annotationNumber,
  },
}: Props) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'conversation.annotation_type',
  })

  const isLgOrAbove = useIsLgOrAbove()

  return (
    <div className="flex flex-col gap-y-1">
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        {Boolean(citations?.length) && (
          <div data-prop="citations" className="flex flex-wrap gap-1">
            {citations?.map(citation => (
              <Badge isOnKarnovNote={isLgOrAbove} isSmall variant="default" key={citation}>
                {citation}
              </Badge>
            ))}
          </div>
        )}

        <div className="kui-subheading flex flex-wrap gap-x-2 gap-y-1 lg:text-default-on-bg-karnovnote">
          {documentCategoryTitle && <span data-prop="documentCategoryTitle">{documentCategoryTitle}</span>}
          {categories?.map(category => <span key={category} data-prop="category">{category}</span>)}
        </div>

      </div>
      <div className="flex flex-col">
        <div className="font-medium" data-prop="title">{title}</div>
        <div data-prop="sectionTitle">{sectionTitle}</div>
        {annotationNumber && (
          <div data-prop="annotation">
            <Text>{`${annotationType ? `${t(annotationType)} ` : ' '}${annotationNumber}`}</Text>
          </div>
        )}
      </div>
    </div>
  )
}
